angular.module('Itao.IndicatorMap').factory('IndicatorSetService', function () {
  'use strict';

  /**
   * IndicatorSet constructor
   * @param {Integer} uid uid of IndicatorSet
   * @param {String} name name of IndicatorSet
   * @param lists
   * @param category
   * @param {String} classidentifier
   * @param colorSet
   * @param sorting
   * @param unit
   * @constructor
   */
  function IndicatorSet(uid, name, lists, category, classidentifier, colorSet, sorting, unit) {
    this.uid = uid;
    this.name = name;
    this.lists = lists;
    this.category = category;
    this.indicators = [];
    this.defaultIndicator = {};
    this.class = classidentifier;
    this.colorSetUid = colorSet;
    this.colorSet = null;
    this.sorting = sorting;
    this.unit = unit;
  }

  /**
   * maps all Indicators to the Set or its lists
   * @param {Object} indicators
   */
  IndicatorSet.prototype.addIndicators = function (indicators) {
    var thisSet = this;
    for(var indicatorUid in indicators) {
      if(indicators.hasOwnProperty(indicatorUid)) {
        var indicator = indicators[indicatorUid];

        if (indicator.type === thisSet.uid) {
          thisSet.indicators.push(indicator);
          if (indicator.isDefault) {
            thisSet.defaultIndicator = indicator;
          }
        }
        var listIndex = thisSet.hasList(indicator.list);
        if (listIndex > -1) {
          // thisSet.lists[listIndex].indicators.push(indicator); // no sorting of list-indicators
          thisSet.lists[listIndex].indicators[indicator.listIndex] = indicator;
          if (indicator.isDefault) {
            thisSet.defaultIndicator = indicator;
            thisSet.unit = indicator.unit;
          }
        }
      }
    }
  };

  /**
   * populates colorSets into the indicatorSets and indicatorLists
   * @param colorSets
   */
  IndicatorSet.prototype.populateColorSets = function (colorSets) {
    if(this.colorSetUid != null && this.colorSetUid !== '0') {
      var currentIndicatorSet = this;
      this.colorSet = colorSets.filter(function(colorSet) {
        return colorSet.uid === currentIndicatorSet.colorSetUid;
      })[0];

      this.lists = this.lists.map(function(list) {
        list.colorSet = colorSets.filter(function(colorSet) {
          return colorSet.uid === list.colorSet;
        })[0];
        return list;
      });
    }
  };

  /**
   * Checks for List
   * @param listId
   * @returns {number}
   */
  IndicatorSet.prototype.hasList = function (listId) {
    return this.lists.reduce(function (prevVal, currentList, index) {
      if (currentList.uid === listId) {
        return index;
      } else {
        return prevVal;
      }
    }, -1);
  };

  /**
   * Checks for List
   * @returns {number}
   */
  IndicatorSet.prototype.getDefaultIndicator = function () {
    return this.indicators.reduce(function (prevVal, currentIndicator) {
      if (currentIndicator.isDefault) {
        return currentIndicator;
      } else {
        return prevVal;
      }
    }, -1);
  };

  return {
    createIndicatorSet: function (uid, name, lists, category, classidentifier, colorSet, sorting) {
      return new IndicatorSet(uid, name, lists, category, classidentifier, colorSet, sorting);
    }
  };
});
